import styles from "./NoSAMResultFound.module.scss";

import classNames from "classnames";

// components
import Blob from "components/icons/Blob";

// assets
import NoResultsImage from "assets/images/error.png";

type NoResultFoundProps = {
  content: string;
  className?: string;
} & JSX.IntrinsicElements["div"];

export default function NoSAMResultFound(props: NoResultFoundProps) {
  const { content, className, ...rest } = props;
  const classes = classNames(styles["no-result-root"], className);

  return (
    <div className={classes} {...rest}>
      <div className={styles["blob"]}>
        <Blob />
        <img src={NoResultsImage} alt="Illustration of a storefront with a gone fishing sign, indicating no results were found" />
      </div>

      <div className={styles["group"]}>
        <h1>No results</h1>
        <p className={styles["desc"]}>
          {content}
        </p>
      </div>
    </div>
  );
}